import React from 'react';
import { element, number, shape, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Endcap } from '@thd-olt-component-react/endcap';
import { Card } from '@thd-olt-component-react/core-ui';
import classnames from 'classnames/bind';
import {
  CUSTOMER_TYPES,
  getSvocId,
  getUserId,
  getMarketingCloudVisitorID,
} from '../../utils';

import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedTopSavingsForYou({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  store,
  customerType,
  id
}) {
  const { storeId } = store;
  /**
   * @TODO
   * Temporary.
   */
  const channel = 'desktop';

  const pageUrl = '/'; // '/N-5yc1vZbx82';

  const personalizedDealsUserid = customerType === CUSTOMER_TYPES.B2B
    ? getSvocId() + '_' + getUserId()
    : getMarketingCloudVisitorID();

  return (
    <QueryProvider cacheKey="endcap">
      <Hydrator
        id="topSavingsForYou-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <Card>
          <Endcap
            /**
             * @TODO
             * Pass from `createComponents` so it's dynamic?
             */
            channel={channel.toUpperCase()}
            customerType={customerType === CUSTOMER_TYPES.B2B ? 'B2B' : 'B2C'}
            pageUrl={pageUrl}
            storeId={storeId}
            personalizedDealsUserid={personalizedDealsUserid}
            showLoading
            entryId={id}
          />
        </Card>
      </Hydrator>
    </QueryProvider>
  );
}

CustomRenderedTopSavingsForYou.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,

  store: shape({
    storeId: string,
    storeZip: string,
  }),
  customerType: string,
  id: string
};

CustomRenderedTopSavingsForYou.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,

  store: {
    storeId: '121',
    storeZip: '30339',
  },
  customerType: 'b2c',
  id: undefined
};
